import { FormInput } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

interface IPlugNotasProps {
  namePrefix: string;
}

const translationPath = "page.4uBus.register.iService.";

export const PlugNotas = memo(({ namePrefix }: IPlugNotasProps) => {
  const { t } = useTranslation();

  const getName = (fieldName: string) => `${namePrefix}.${fieldName}`;

  return (
    <>
      <Grid item xs={12}>
        <FormInput
          size="small"
          name={getName("baseUrl")}
          label={t(translationPath + "base_url")}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <FormInput
          size="small"
          name={getName("token")}
          label={t(translationPath + "token")}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <FormInput
          size="small"
          name={getName("defaultProviderDocument")}
          label={t(translationPath + "default_provider_document")}
          fullWidth
        />
      </Grid>
    </>
  );
});
